import styled from 'styled-components';
import { snakeCase } from 'lodash';
import { globalTheme } from '@clds/component-theme';
import t from 'common/i18n';
import { useFilterParams, useSearchParams, useUI } from '../../selectors';
import { secondsToMinutes } from '../../utils';

export const SummaryBox = styled.div`
  padding: ${globalTheme.spacing.xs} ${globalTheme.spacing.sm};
  border-bottom: 1px solid ${globalTheme.palette.secondary};
  font-weight: bold;
  display: flex;
  flex-wrap: wrap;
`;

const ElementBox = styled.div`
  display: flex;
  padding-right: ${globalTheme.spacing.xxs};
`;
const ColorFilterBox = styled.div`
  display: flex;
`;
export const ColorBox = styled.div`
  width: 12px;
  height: 12px;
  border-radius: ${globalTheme.radius.md};
  background: ${({ color }) => color};
  border: 1px solid ${globalTheme.palette.secondary};
  position: relative;
  top: 1px;
  left: 3px;
`;

export default ({ source, filterSet, disabledFilters = {} }) => {
  const filters = useFilterParams(source);
  const { searchPhrase } = useSearchParams(source);
  const { areFiltersSet } = useUI(source);

  const filtersList = [];
  if (searchPhrase) {
    filtersList.push(`[${searchPhrase}]`);
  }

  Object.keys(filters).forEach((filter) => {
    if (filterSet.includes(filter) && filters[filter] && !disabledFilters[filter] && areFiltersSet) {
      if (filters[filter] === true) {
        filtersList.push(t(`${source}.filters.summary.${snakeCase(filter)}`));
      } else if (filter === 'color') {
        const color = filters[filter];
        filtersList.push(
          <ColorFilterBox>
            {t(`${source}.filters.summary.color`, { color })}
            <ColorBox color={color} />
          </ColorFilterBox>
        );
      } else if (filter === 'duration') {
        const duration = filters[filter];
        filtersList.push(
          <>
            {secondsToMinutes(duration[0])} - {secondsToMinutes(duration[1])}
          </>
        );
      } else if (filter === 'frameRates') {
        filtersList.push(...filters[filter].map((f) => `${f} FPS`));
      } else if (filter === 'formatAvailable') {
        filtersList.push(...filters[filter]);
      } else if (Array.isArray(filters[filter]) && filters[filter]?.length) {
        filtersList.push(...filters[filter].map((f) => t(`${source}.filters.summary.${snakeCase(filter)}.${f}`)));
      } else if (!Array.isArray(filters[filter])) {
        filtersList.push(t(`${source}.filters.summary.${snakeCase(filter)}.${filters[filter]}`));
      }
    }
  });

  return (
    <>
      {(searchPhrase || areFiltersSet) && (
        <SummaryBox data-test="filters-summary">
          <ElementBox>{t(`${source}.filters.summary.label`)}:</ElementBox>
          {filtersList.map((item, i) => (
            <ElementBox key={i}>
              {item}
              {i >= 0 && i < filtersList.length - 1 ? ',' : null}
            </ElementBox>
          ))}
        </SummaryBox>
      )}
    </>
  );
};
